import { useEffect } from 'react';
import style from './style.module.css'
import { BaseURL } from '../../../config/axios'

const UploadImage = ({ setProduct, images }) => {

    useEffect(() => {
        window.addEventListener('click', handleRemove)
        return () => window.removeEventListener('click', handleRemove)
    }, [])

    function handleRemove(e) {
        if (e.target.id === 'upload_img') {
            const el = e.target.parentElement
            const file = el.getAttribute('data-file')
            const fileName = el.getAttribute('file-name')
            setProduct(prev => {
                if (fileName) {
                    const { image, ...data } = prev
                    return { ...data }
                } else if (file) {
                    const deletedImage = prev.images.find(i => i.name === file)
                    const clearList = prev.images.filter(i => i !== deletedImage)
                    return { ...prev, images: clearList }
                }
            })
            el.remove();
        }
    }

    const handleMultipleImage = (e) => {
        const imgArray = [];
        const fileArry = e.target.parentElement.parentElement.parentElement.children[3]
        for (const file of e.target.files) {
            imgArray.push(file);
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.addEventListener('load', function () {
                let html = `
                <div className='${style.upload__img_box}' data-file='${file.name}' >
                    <img src='${this.result}' className='h-full object-contain' />
                    <div className=${style.upload__img_close} id='upload_img'></div>
                </div>`;
                fileArry.innerHTML += html
            })
        }
        setProduct(prev => {
            return {
                ...prev,
                images: [...prev.images, ...imgArray]
            }
        })
    }

    const handleImageOption = (e) => {
        const name = parseInt(e.target.name)
        setProduct(prev => {
            const { remove_image_ids } = prev
            if (!remove_image_ids.includes(name)) {
                remove_image_ids.push(name);
            } else {
                remove_image_ids.splice(remove_image_ids.indexOf(name), 1);
            }
            return prev
        })
    }

    return (
        <>
            <div className={style.iJIucw}>
                <div className={style.form_group}>
                    {!!images && images.length > 0 &&
                        <>
                            <label className={style.control_label}>جهت حذف، روی عکس مورد نظر کلیک کنید.</label>
                            <div className={style.OvrcU}>
                                {images.map(i => {
                                    return (
                                        <div key={i.id} className={style.ExBt_2}>
                                            <input
                                                type="checkbox"
                                                name={i.id}
                                                id={`image${i.id}`}
                                                hidden
                                                onChange={handleImageOption}
                                            />
                                            <label htmlFor={`image${i.id}`} className={style.image_holder}>
                                                <img src={BaseURL + i.path} alt="imagePost" className='w-full h-full object-contain' />
                                            </label>
                                        </div>
                                    )
                                })}
                            </div>
                        </>
                    }
                </div>
                <div className={style.upload__btn_box}>
                    <label className={style.upload__btn} htmlFor="inputFiles">
                        <p>آپلود تصاویر</p>
                        <input onChange={handleMultipleImage}
                            type="file" name="image" id="inputFiles"
                            hidden multiple
                            accept='image/jpeg, image/jpg, image/png, image/webp' />
                    </label>
                </div>
                <div className={style.upload_main_img_wrap}></div>
                <div className={style.upload__img_wrap}> </div>
            </div>
        </>
    );
};

export default UploadImage;